export enum PitchUploadStep {
  upload = 'upload',
  preview = 'preview',
  design = 'design',
}

export enum PitchUploaderTab {
  Errors = 'Errors',
  BallData = 'BallData',
  CsvData = 'CsvData',
}
